<template>
<div>
    <div class="ibox-content">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label>Nombre</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                        </div>
                        <input class="form-control " placeholder="Nombre" readonly type="text" v-model="servicio_json.nombre">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Código de integración</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-addon"><i class="fal fa-barcode"></i> </span>
                        </div>
                        <input class="form-control " placeholder="Código de integración" readonly="" v-model="servicio_json.UUID">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Confirmable (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Permitir realizar la confirmación de las horas de este servicio."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <input v-model="servicio_json.confirmable" type="checkbox" class="js-switch" data-switchery="true" style="display: none" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label>Duracion</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                        </div>
                        <input class="form-control " placeholder="Nombre" readonly type="text" v-model="servicio_json.duracion">
                    </div>
                </div>
            </div>
            <div class="col-md-4" v-if="servicio_json.area">
                <div class="form-group">
                    <label>Area</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                        </div>
                        <input class="form-control " placeholder="Nombre" readonly type="text" v-model="servicio_json.area.nombre">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Especialidad</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                        </div>
                        <input class="form-control " placeholder="Nombre" readonly type="text" v-model="servicio_json.especialidad.nombre">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Preparación(<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Dias que se deben tener de preparacion para el usuario."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-addon"><i class="fal fa-clock"></i> </span>
                        </div>
                        <input class="form-control" placeholder="Dias de preparacion" type="number" v-model="servicio_json.dias_preparacion">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Flujo</label>
                    <div class="input-group">
                        <select class="custom-select" v-model="servicio_json.id_flujo">
                            <option disabled value="">Seleccione un elemento</option>
                            <option v-for="(flujo, index) in flujos_list" :key="index" v-bind:value="flujo.id">
                                {{ flujo.nombre }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>Indicaciones</label>
                    <div class="input-group">
                        <textarea class="form-control" rows="4" v-model="servicio_json.indicaciones"></textarea>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>Texto Personalizado Voucher Agendamiento</label>
                    <div class="input-group">
                        <textarea class="form-control" rows="2" v-model="servicio_json.texto_personalizado_agendamiento"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Agendable (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Permitir agendar."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <input @change="handleAgendableChange()" id="cb-agendable" v-model="servicio_json.agendable" type="checkbox" class="js-switch" data-switchery="true" style="display: none" />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Agendable Web (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Permitir agendar via web."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <input @change="changeAgendable('web')" id="cb-agendable-web" v-model="servicio_json.agendable_web" type="checkbox" class="js-switch" data-switchery="true" style="display: none" />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Agendable Ejecutivo (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Permitir agendar via web a ejecutivos."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <input @change="changeAgendable('ejecutivo')" id="cb-agendable-ejecutivo" v-model="servicio_json.agendable_ejecutivo" type="checkbox" class="js-switch" data-switchery="true" style="display: none" />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Agendable Whatsapp (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Permitir agendar via canal whatsapp."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <input @change="changeAgendable('whatsapp')" id="cb-agendable-whatsapp" v-model="servicio_json.agendable_whatsapp" type="checkbox" class="js-switch" data-switchery="true" style="display: none" />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Agendable Teléfono (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Permitir agendar via canal teléfono."><i class="fa fa-question-circle"></i></a>)</label>
                    <div class="input-group">
                        <input @change="changeAgendable('telefono')" id="cb-agendable-telefono" v-model="servicio_json.agendable_telefono" type="checkbox" class="js-switch" data-switchery="true" style="display: none" />
                    </div>
                </div>
            </div>
        </div>
        <hr v-if="list.length > 0" />
        <div class="row" v-for="(item, index) in list" :key="index" style="border-bottom: 1px solid #bfbfbfee;    margin-bottom: 16px;">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Establecimiento {{index+1}}</label>
                    <div class="input-group">
                        <multiselect label="nombre" :multiple="true" :taggable="true" track-by="id" v-model="item.establecimientos" :options="establecimientos_list"></multiselect>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Estrategia {{index+1}}</label>
                    <div class="input-group">
                        <select class="custom-select" v-model="item.estrategia">
                            <option disabled value="">Seleccione un elemento</option>
                            <option v-for="(estrategia, index3) in estrategias_list" :key="index3" v-bind:value="estrategia.id">
                                {{ estrategia.nombre }}
                            </option>
                        </select>
                        <!-- <input placeholder="Abreviatura" v-model="item.estrategia" type="text" class="form-control" /> -->
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Tipo Cita {{index+1}}</label>
                    <div class="input-group">
                        <multiselect label="abrev" :multiple="true" :taggable="true" track-by="id" v-model="item.tipo_citas" :options="tipo_cita_list"></multiselect>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Eliminar</label>
                    <div class="input-group">
                        <button class="btn btn-secondary" @click="eliminar(index)">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <a href="javascript:void(0)" @click="add">Añadir Estrategia</a>
            </div>
        </div>
    </div>
    <div class="ibox-footer">
        <div class="row">
            <div class="col-md-4 offset-md-8">
                <div class="btn-group float-right">
                    <button type="submit" class="btn btn-primary" @click="save">
                        <i class="fal fa-save"></i> Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: { Multiselect },
    props: ["servicio", "establecimientos", "estrategias", "tipo_cita", 'id', 'test_ab', 'flujos'],
    data() {
        return {
            servicio_json: {
                especialidad: {
                    nombre: null
                }
            },
            list: [],
            establecimientos_list: [],
            estrategias_list: [],
            tipo_cita_list: [],
            flujos_list: [],
        };
    },
    mounted() {
        this.servicio_json = JSON.parse(this.servicio);
        this.estrategias_list = JSON.parse(this.estrategias);
        this.establecimientos_list = JSON.parse(this.establecimientos);
        this.tipo_cita_list = JSON.parse(this.tipo_cita);
        this.flujos_list = JSON.parse(this.flujos);
        if (this.servicio_json.id_flujo === null) {
            this.servicio_json.id_flujo = 1;
        }

        let establecimientos = [];
        let tipo_citas = [];
        // console.log(this.test_ab);
        this.list = JSON.parse(this.test_ab).map(element => {
            establecimientos = [];
            tipo_citas = [];
            const map_establecimientos = new Map();
            const map_tipo_cita = new Map();
            for (const item of element.establecimientos) {
                if (!map_establecimientos.has(item.id_establecimiento)) {
                    map_establecimientos.set(item.id_establecimiento, true); // set any value to Map
                    establecimientos.push(item.establecimiento);
                }
                // console.log(item);
                if (!map_tipo_cita.has(item.id_tipocita)) {
                    map_tipo_cita.set(item.id_tipocita, true); // set any value to Map
                    tipo_citas.push(item.tipo_cita);
                }
            }
            return {
                establecimientos: establecimientos,
                estrategia: element.estrategia.id,
                tipo_citas: tipo_citas,
                id: element.id
            }
        });

        // console.log(this.list);
        // this.handleAgendableChange();
    },
    methods: {
        changeAgendable(variable) {
            if (!this.servicio_json.agendable && this.servicio_json['agendable_'+variable]) {
                $('#cb-agendable').click();
            }
        },
        handleAgendableChange() {
            if (!this.servicio_json.agendable) {
                if ($('#cb-agendable-web').is(':checked')) {
                    $('#cb-agendable-web').click();
                }
                if ($('#cb-agendable-ejecutivo').is(':checked')) {
                    $('#cb-agendable-ejecutivo').click();
                }
                if ($('#cb-agendable-whatsapp').is(':checked')) {
                    $('#cb-agendable-whatsapp').click();
                }
                if ($('#cb-agendable-telefono').is(':checked')) {
                    $('#cb-agendable-telefono').click();
                }
            }
        },
        add() {
            let x = {
                establecimientos: this.establecimientos_list,
                estrategia: "",
                tipo_citas: [],
                id: null
            };
            this.list.push(x);
        },
        save() {
            // this.servicio_json = this.list;
            let flag = true;
            let establecimientos = [];
            let array_objects = [];
            let temp = [];
            this.servicio_json['id'] = this.id;
            this.servicio_json['list'] = this.list.map((element, index) => {
                if (!this.filtrar_vacio(element, index) || !flag) {
                    flag = false;
                    return;
                }
                establecimientos = [];
                if (flag)
                    for (const element2 of element.establecimientos) {
                        establecimientos.push(element2.id);

                        for (let index2 = 0; index2 < element.tipo_citas.length; index2++) {
                            let obj = {
                                id_establecimiento: element2.id,
                                establecimiento_nombre: element2.nombre,
                                id_tipo_cita: element.tipo_citas[index2].id,
                                tipo_cita_abrev: element.tipo_citas[index2].abrev,
                                indice: index + 1
                            };
                            temp = array_objects.filter((filtro => {
                                return filtro.id_establecimiento == obj.id_establecimiento && filtro.id_tipo_cita == obj.id_tipo_cita
                            }))

                            if (temp.length > 0) {
                                this.$swal.fire({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: 'ERROR "' + temp[0].establecimiento_nombre + '" se repite con el mismo tipo de cita en establecimiento ' + temp[0].indice + ' y establecimiento ' + obj.indice + '!',
                                    showConfirmButton: true,
                                    timer: 5000,

                                });
                                flag = false;
                                break;

                            } else {
                                array_objects.push(obj);
                            }
                        }

                        if (!flag)
                            break;
                    }
                return {
                    establecimientos: establecimientos,
                    estrategia: element.estrategia,
                    tipo_citas: element.tipo_citas.map(element3 => { return element3.id }),
                    id: element.id
                }
            });
            if (!flag) { return; }
            axios.post("", this.servicio_json).then((response) => {
                    console.log(response);
                    window.history.back();/*  */
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        eliminar(index) {
            this.list.splice(index, 1);
        },
        filtrar_vacio(element, index) {
            if (element.establecimientos.length == 0) {
                this.$swal.fire({
                    position: 'top-center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Los establecimientos No.' + (index + 1) + ' no pueden quedar vacios!',
                    showConfirmButton: true,
                    timer: 3000,

                });
                return false;
            }
            if (element.estrategia == "") {
                this.$swal.fire({
                    position: 'top-center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'La estrategia No.' + (index + 1) + ' no puede quedar vacia!',
                    showConfirmButton: true,
                    timer: 3000
                });
                return false;
            }
            if (element.tipo_citas.length == 0) {
                this.$swal.fire({
                    position: 'top-center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Los Tipo Cita No.' + (index + 1) + ' no pueden quedar vacios!',
                    showConfirmButton: true,
                    timer: 3000
                });
                return false;
            }

            return true;
        }
    },
}
</script>
